import { ValueTypeSwitcher } from 'legacy/lut/components/widgets/public/partner360/common/valueTypeSwitcher/ValueTypeSwitcher'
import { useMemo } from 'react'

import { FormDropdown } from 'cng-common/features/form'
import { useSafetyTranslation } from 'cng-common/features/translations'
import { Static } from 'core-components/types'
import { Crud } from 'core/types'
import { CurrenciesButtons } from 'partner360/components/currenciesButtons'
import {
  controlsInitialData,
  dashboardChartMeasureOptions,
  dashboardGroupByOptions,
  KEY_INITIATIVE_CONTROLS_FORM,
} from 'partner360/features/keyInitiatives/configs/config'
import { DashboardChartMeasure } from 'partner360/features/keyInitiatives/model/types'
import { DashboardLabel } from 'partner360/features/keyInitiatives/ui/common/dashboardLabel/DashboardLabel'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { TRANSLATION_KEYS } from '../../configs/translations'

import styles from './KeyInitiativesControls.module.scss'

export interface IKeyInitiativesControls {
  actualsType: ActualsValueTypes
  onChangeActualsType: (value: ActualsValueTypes) => void
  actualsTypes: ActualsValueTypes[]
}

export const KeyInitiativesControls = ({
  actualsType,
  onChangeActualsType,
  actualsTypes,
}: IKeyInitiativesControls) => {
  const t = useSafetyTranslation()
  const dashboardGroupByOptionsSource = useMemo(() => {
    return new Crud({
      fetcher: new Static(dashboardGroupByOptions),
      keyField: 'key',
    })
  }, [])

  const dashboardChartMeasureOptionsSource = useMemo(() => {
    return new Crud({
      fetcher: new Static(
        dashboardChartMeasureOptions.map((option) => ({
          ...option,
          label: option.key === DashboardChartMeasure.Goal ? t(option.label) : option.label,
        }))
      ),
      keyField: 'key',
    })
  }, [t])

  return (
    <div>
      <div className={styles.content}>
        <div className={styles.field}>
          <DashboardLabel translationKey={TRANSLATION_KEYS.dashboard.controls.groupBy} />

          <FormDropdown
            defaultValue={controlsInitialData.groupBy}
            field={'groupBy'}
            formKey={KEY_INITIATIVE_CONTROLS_FORM}
            source={dashboardGroupByOptionsSource}
            caption={'label'}
            isStatic
          />
        </div>

        <div className={styles.field}>
          <DashboardLabel translationKey={TRANSLATION_KEYS.dashboard.controls.chartMeasure} />

          <FormDropdown
            defaultValue={controlsInitialData.chartMeasure}
            field={'chartMeasure'}
            formKey={KEY_INITIATIVE_CONTROLS_FORM}
            source={dashboardChartMeasureOptionsSource}
            caption={'label'}
            isStatic
          />
        </div>

        <div className={styles.field}>
          <DashboardLabel translationKey={TRANSLATION_KEYS.dashboard.controls.currency} />

          <CurrenciesButtons size="small" />
        </div>

        <div className={styles.field}>
          <DashboardLabel translationKey={TRANSLATION_KEYS.dashboard.controls.unitsMeasure} />

          <ValueTypeSwitcher
            onChangeValueType={onChangeActualsType}
            valueTypes={actualsTypes}
            valueType={actualsType}
            size={'small'}
          />
        </div>
      </div>
    </div>
  )
}
